export default "__VITE_ASSET__C2X16Edn__"